import { hasRoles, useAuth } from "auth";
import React, { FC, ReactNode } from "react";
import { NoRolesAssigned } from "./NoRolesAssigned";

interface Props {
  readonly children: ReactNode;
}

export const Authentication: FC<Props> = ({ children }) => {
  const { auth } = useAuth();

  if (!auth?.authenticated) {
    return null;
  }

  const userHasRoles = auth.hasRoles ? auth.hasRoles() : hasRoles(auth.account);

  if (!userHasRoles) {
    return <NoRolesAssigned />;
  }

  return <>{children}</>;
};
